import { defineComponent as _defineComponent } from 'vue'
import {useModalInstance} from '@/composables/useModalInstance';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {Offer} from '@/models/simulation/Simulation';
import LoanApplication from '@/models/LoanApplication';
import {Bank} from '@/modules/banks/models/Bank';
import DealsApi from '@/modules/deals/services/DealsApi';
import {computed, getCurrentInstance, ref} from 'vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import User from '@/models/user/User';
import {BankSymbol} from '@/commons/dictionaries/BankSymbol';
type ModalData = {
  selectedOffers: Offer[];
  user: User;
}

enum Lists {
  SELECTED,
  EXISTING,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AddOffersToDealModal',
  setup(__props) {

const RaiffeisenAccessInfo = () => import(/* webpackChunkName: "RaiffeisenAccessInfo" */ '@/components/calculator/results/RaiffeisenAccessInfo.vue');

const instance = getCurrentInstance();
const modal = useModalInstance<ModalData, boolean | Offer[]>();
const store = useSimulationStore();
const expanded = ref<Lists[]>([Lists.SELECTED,]);
const existingLoanApplications = ref<LoanApplication[]>([]);

const selectedLoanApplications = computed<LoanApplication[]>(() => {
  return modal.modalData.selectedOffers.map(transformOfferToLoanApplication);
});

const offers = computed<Offer[]>(() => {
  return modal.modalData.selectedOffers;
});

const hasAccessToRaiffeisen = computed<boolean>(() => {
  return modal.modalData.user!.privileges.hasAccessToRaiffeisen;
});

const isRaiffeisenOfferSelected = computed<boolean>(() => {
  return modal.modalData.selectedOffers?.some(offer => offer.info.bank === BankSymbol.RAIFFEISEN) || false;
});

const selectedOffersCount = computed<number>(() => {
  return modal.modalData.selectedOffers?.length || 0;
});

const addOffersWithoutRaiffeisen = () => {
  const offers = modal.modalData.selectedOffers.filter(offer => offer.info.bank !== BankSymbol.RAIFFEISEN);
  modal.closeModal(offers);
};

const getLoanPeriod = (offer: Offer): number => {
  const loanPeriodInMonths: number = offer.customizations?.customLoanPeriodInMonths ||
    (store.isMortgage ? store.userInput?.loanPeriodInMonths : store.userInput?.loanPeriod) || 0;
  return store.isMortgage ? Math.round(loanPeriodInMonths / 12) : loanPeriodInMonths;
};

const getLoanAmount = (offer: Offer): number =>
  offer.customizations?.customLoanAmount || store.userInput?.loanAmount || 0;

const transformOfferToLoanApplication = (offer: Offer): LoanApplication => new LoanApplication({
  bank: {name: offer.info.bankName, symbol: offer.info.bank,} as unknown as Bank,
  name: offer.info.title,
  shortName: offer.shortName,
  amount: getLoanAmount(offer),
  period: getLoanPeriod(offer),
} as unknown as LoanApplication);

const fetchLoanApplications = async(): Promise<void> => {
  try {
    existingLoanApplications.value = await DealsApi.getLoanApplicationsByDealId(store.deal!.id);
  } catch (e) {
    instance?.proxy.errorHandler(e, I18NGetter().useDealDetails.FETCH_LOAN_APPLICATIONS_ERROR_HANDLER);
  }
};

fetchLoanApplications();

return { __sfc: true,RaiffeisenAccessInfo, Lists, instance, modal, store, expanded, existingLoanApplications, selectedLoanApplications, offers, hasAccessToRaiffeisen, isRaiffeisenOfferSelected, selectedOffersCount, addOffersWithoutRaiffeisen, getLoanPeriod, getLoanAmount, transformOfferToLoanApplication, fetchLoanApplications }
}

})